import { TableCell, TableRow } from "@mui/material";
import { useSelector } from "react-redux";
import selectors from "selectors";

const UpcomingChatError = () => {
  const speaksSpanish = useSelector(selectors.getSpeaksSpanish);

  return (
    <TableRow>
      <TableCell>
        <div
          className="upcoming-chat-date-container"
          style={{
            fontWeight: "bold",
            background: "rgb(204, 2, 2)",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          ERROR
        </div>
      </TableCell>
      <TableCell colSpan={6}>
        {speaksSpanish
          ? "Se han detectado errores con una cita. Por favor contacte a soporte."
          : "We found issues with an appointment. Please contact support."}
      </TableCell>
    </TableRow>
  );
};

export default UpcomingChatError;
